import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ListPagerSizePickerComponent } from './list-pager-size-picker/list-pager-size-picker.component';
import { ListPagerComponent } from './list-pager.component';

@NgModule({
    declarations: [ListPagerComponent, ListPagerSizePickerComponent],
    imports: [CommonModule],
    exports: [ListPagerComponent]
})
export class ListPagerModule {}
